import type { AttributeEditModeConfig } from '@source-components-react/types';
import { DEFAULT_BUTTON_PRESET } from './button-presets';
import {
  BUTTON_DISABLED_ATTRIBUTE,
  BUTTON_ICON_ATTRIBUTE,
  BUTTON_ICON_POSITION_ATTRIBUTE,
  BUTTON_LABEL_ATTRIBUTE,
  BUTTON_LINK_ATTRIBUTE,
  BUTTON_PRESET_ATTRIBUTE,
  DEFAULT_ICON_POSITION,
} from './button-attributes';

/**
 * Every setting the button offers, in the order the Modify drawer shows them:
 * how it looks, what it says, where it goes, then the two refinements most
 * buttons never need.
 *
 * Order is not cosmetic. The drawer renders these top to bottom and the
 * documentation registry asserts its pages match that sequence, so moving an
 * entry here moves it in both places at once.
 */
export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: BUTTON_PRESET_ATTRIBUTE,
    heading: 'Button Style',
    subHeading:
      'Variant, tone and size. Sets how the button looks when Column Styles leave it alone — anything set there wins, for 3 different device resolutions',
    defaultValues: { all: DEFAULT_BUTTON_PRESET },
  },
  {
    name: BUTTON_LABEL_ATTRIBUTE,
    heading: 'Label',
    subHeading: 'Text shown on the button. Clear it for an icon-only button',
    defaultValues: {},
  },
  {
    name: BUTTON_LINK_ATTRIBUTE,
    heading: 'Link',
    subHeading:
      'Where the button goes. Setting it renders an anchor styled as a button; leaving it empty renders a plain button, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: BUTTON_ICON_ATTRIBUTE,
    heading: 'Icon',
    subHeading:
      'Optional icon shown beside the label. Search by name or by what the icon depicts (e.g. "launch" finds the rocket), for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: BUTTON_ICON_POSITION_ATTRIBUTE,
    heading: 'Icon Position',
    subHeading: 'Whether the icon sits before or after the label',
    defaultValues: { all: DEFAULT_ICON_POSITION },
  },
  {
    name: BUTTON_DISABLED_ATTRIBUTE,
    heading: 'Disabled',
    subHeading: 'Renders the button dimmed and non-interactive',
    defaultValues: {},
  },
];
